module.exports = __webpack_public_path__ + "static/media/coins_3.a528e6f0.webp";